import React, { useState } from 'react';
import { Button } from '../Button';
import { TicketIcon, SaveIcon, PlusIcon, DeleteIcon } from './DashboardIcons';

interface Plan {
    id: number;
    title: string;
    price: string;
    priceDetails: string;
    features: string[];
}

const initialPlans: Plan[] = [
    { id: 1, title: "Defensa Esencial", price: "49€", priceDetails: "/ multa", features: ["Análisis de viabilidad", "Redacción de alegaciones", "Seguimiento online"] },
    { id: 2, title: "Defensa Avanzada", price: "89€", priceDetails: "/ multa", features: ["Todo lo Esencial", "Gestión de conductor", "Recurso de alzada", "Asesoramiento pronto pago"] },
    { id: 3, title: "Protección Anual", price: "199€", priceDetails: "/ año", features: ["Cobertura total (hasta 5 multas)", "Asesoramiento continuo", "Control de puntos", "Incluye defensa avanzada"] },
];

export const PricesView: React.FC = () => {
    const [plans, setPlans] = useState<Plan[]>(initialPlans);
    const [recommendedPlanId, setRecommendedPlanId] = useState<number>(2);

    const handlePlanChange = (id: number, field: keyof Plan, value: any) => {
        setPlans(plans.map(p => p.id === id ? { ...p, [field]: value } : p));
    };
    
    const handleFeatureChange = (planId: number, featureIndex: number, value: string) => {
        const newPlans = [...plans];
        const plan = newPlans.find(p => p.id === planId);
        if (plan) {
            plan.features[featureIndex] = value;
            setPlans(newPlans);
        }
    };
    
    const addFeature = (planId: number) => {
        const newPlans = [...plans];
        const plan = newPlans.find(p => p.id === planId);
        if (plan) {
            plan.features.push('');
            setPlans(newPlans);
        }
    };

    const removeFeature = (planId: number, featureIndex: number) => {
        const newPlans = [...plans];
        const plan = newPlans.find(p => p.id === planId);
        if (plan) {
            plan.features.splice(featureIndex, 1);
            setPlans(newPlans);
        }
    };

    const handleSaveChanges = () => {
        console.log("Saving prices:", { plans, recommendedPlanId });
        alert("Planes y precios guardados.");
    };

    return (
        <div className="p-8 bg-white rounded-lg shadow-sm">
            <h1 className="text-2xl font-bold text-gray-800 flex items-center mb-6"><TicketIcon /><span className="ml-2">Gestión de Planes y Precios</span></h1>

            <div className="grid md:grid-cols-3 gap-8">
                {plans.map(plan => (
                    <div key={plan.id} className={`flex flex-col rounded-lg shadow-md overflow-hidden h-full border-2 ${recommendedPlanId === plan.id ? 'border-blue-500' : 'border-gray-200'}`}>
                        <div className="p-6 bg-gray-50 space-y-3">
                            <input type="text" value={plan.title} onChange={e => handlePlanChange(plan.id, 'title', e.target.value)} className="w-full p-2 border rounded font-bold text-lg" />
                            <div className="flex items-baseline">
                                <input type="text" value={plan.price} onChange={e => handlePlanChange(plan.id, 'price', e.target.value)} className="w-24 p-2 border rounded text-2xl font-extrabold" />
                                <input type="text" value={plan.priceDetails} onChange={e => handlePlanChange(plan.id, 'priceDetails', e.target.value)} className="w-full p-2 border rounded ml-1 text-gray-600" />
                            </div>
                        </div>
                        <div className="p-6 bg-white flex-grow">
                             <h4 className="font-semibold text-sm mb-2">Características:</h4>
                             <div className="space-y-2">
                                {plan.features.map((feature, index) => (
                                    <div key={index} className="flex items-center gap-2">
                                        <input type="text" value={feature} onChange={e => handleFeatureChange(plan.id, index, e.target.value)} className="w-full p-1.5 border rounded text-sm" />
                                        <button onClick={() => removeFeature(plan.id, index)} className="text-red-500 hover:text-red-700 p-1"><DeleteIcon /></button>
                                    </div>
                                ))}
                             </div>
                             <Button onClick={() => addFeature(plan.id)} size="small" className="mt-3 bg-gray-200 text-gray-700 hover:bg-gray-300 w-full"><PlusIcon /></Button>
                        </div>
                        <div className="p-4 bg-gray-50 border-t">
                            <label className="flex items-center justify-center">
                                <input type="radio" name="recommended" checked={recommendedPlanId === plan.id} onChange={() => setRecommendedPlanId(plan.id)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"/>
                                <span className="ml-2 text-sm font-medium">Marcar como Recomendado</span>
                            </label>
                        </div>
                    </div>
                ))}
            </div>
            
            <div className="mt-8 pt-6 border-t border-gray-200 flex justify-end">
                <Button onClick={handleSaveChanges} variant="success" size="large">
                    <span className="flex items-center"><SaveIcon /><span className="ml-2">Guardar Precios</span></span>
                </Button>
            </div>
        </div>
    );
};